import React, { useEffect } from "react";
import Navbar from "./Navbar";
import Inicio from "./Inicio";
import Funciones from "./Funciones";
import Precios from "./Precios";
import Footer from "./Footer";
import { useLocation } from "react-router-dom";
import Seguridad from "./Landings/Seguridad"; // Ajusta el path si cambia
import PreguntasFrecuentes from "./Landings/Preguntasfrecuentes";
import Testimonios from './Testimonios';
import useSEO from "../utils/useSEO";
import paginas from "../utils/paginas.json";

// Convierte la lista en un buscador por ruta. Ejemplo: SEO_PAGINAS["/seguridad"]
const SEO_PAGINAS = Object.fromEntries(paginas.map((p) => [p.ruta, p]));

const Home = () => {
  const location = useLocation();
  const isSeguridadPage = location.pathname === "/seguridad";
  const isPreguntasFrecuentesPage = location.pathname === "/preguntas-frecuentes";
  useSEO(SEO_PAGINAS[location.pathname] || SEO_PAGINAS["/"]);
    useEffect(() => {
    // Si la dirección trae una sección (#features, #pricing), bajamos a ella
    if (location.hash) {
      const seccion = document.getElementById(location.hash.slice(1));
      if (seccion) {
        seccion.scrollIntoView();
        return;
      }
    }
    // Si no, empezamos hasta arriba (como antes)
    window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);


  return (
    <>
      <Navbar />
      {isSeguridadPage ? (
        <Seguridad />
      ) : isPreguntasFrecuentesPage ? (
        <PreguntasFrecuentes />
      ) : (
        <>
          <Inicio />
          <Funciones />
          <Testimonios />
          <Precios />
        </>
      )}
      <Footer />
    </>
  );
};

export default Home;